import { DisplayObject, Rectangle } from '@creately/createjs-module';
import { Logger, StateService } from 'flux-core';
import { ITransform } from 'flux-definition/src';
import { TextDataModel } from 'flux-diagram-composer';
import { EMPTY, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { ShapeTextEditorPositionService } from '../../../ui/text-editor/shape-text-editor-position.svc';
import { TiptapDocumentsManagerShapeText } from '../../../ui/text-editor/tiptap-documents-manager-shape-text.cmp';


// tslint:disable:member-ordering
/**
 * TiptapShapeDomView for 'dom' Tiptap rendering
 */
export class TiptapShapeDomView extends DisplayObject {

    public static shapeTextEditorPositionSvc: ShapeTextEditorPositionService;
    public static state: StateService<any, any>;

    public _html: string;
    protected diagramId;

    protected positionSubscription: Subscription;

    constructor(  protected model: TextDataModel, protected shapeId ) {
        super();
        model.html = model.html.replace( /<tiptap-iframe-node-view/g,
            `<tiptap-iframe-node-view shapeid="${ shapeId }"` );
        this.html = model.html;
        this.name = model.id;
        this.diagramId = TiptapShapeDomView.state?.get( 'CurrentDiagram' );
        // We use shape text editor itself to render this TiptapShapeDomView by making the corresponding
        // tiptap child editor node visible always.
        this.update( model );
    }

    public set html( value: string ) {
        this._html =  value;
    }

    /**
     * Overrding the easeljs DisplayObject's draw function
     * We don't draw on the canvas
     */
    public draw( ctx: CanvasRenderingContext2D, ignoreCache: boolean = false ) {
        // Nothing to draw in the canvas
        return true;
    }

    public update( model: TextDataModel, _change?: any,  _bounds?: Rectangle, _transfrom?: ITransform ) {
        const textModel = model;
        const diagramId = this.diagramId;
        const shapeId = this.shapeId;
        TiptapDocumentsManagerShapeText.setTiptapDocumentZIndex( 'restore' );
        TiptapDocumentsManagerShapeText.setShapeTextNodeVisibility( diagramId, shapeId, textModel.id, 'visible' );
        const sel = `tiptap-editor-component[id="${diagramId}"].shapeText div[data-type="tiptap-child-editor-node"][shapeId="${ shapeId }"][textId="${ textModel.id }"] .tiptap-child-editor-content`;
        if ( this.positionSubscription ) {
            this.positionSubscription.unsubscribe();
        }
        this.positionSubscription = TiptapShapeDomView.shapeTextEditorPositionSvc
            .updateLocation( sel, shapeId, textModel, EMPTY ).pipe(
                // take( 1 ),
                map(({ positionStyles }) => {
                    TiptapDocumentsManagerShapeText.handlePositionStyles(
                        diagramId,
                        shapeId,
                        textModel.id,
                        positionStyles,
                        'none',
                    );
        })).subscribe();
    }

    public destroy() {
        if ( this.positionSubscription ) {
            this.positionSubscription.unsubscribe();
        }
        if ( !this.parent ) {
            Logger.error( 'TiptapTextView.destroy called but this.parent was null.' );
            return;
        }
        this.parent.removeChild( this );
    }

}
